import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSearchWorkers } from "../../../context/SearchWorkersContext";
import genderOptions from "./data/genderOptions.json";

const WorkerSupportGender = ({
  onUpdate,
  supportGenderValue,
  isError,
  clearError,
}) => {
  const { getSelectionIdFromCookies, searchSelections } = useSearchWorkers();

  const [selectedGender, setSelectedGender] = useState(
    searchSelections?.genderDetails || supportGenderValue || null
  );

  const navigate = useNavigate();

  useEffect(() => {
    const selectionId = getSelectionIdFromCookies();
    console.log(
      "[WorkerSupportGender] Retrieved selectionId from cookies:",
      selectionId
    );
    if (!selectionId) {
      console.warn("No selectionId found. Redirecting to /search-workers...");
      navigate("/account/fs-dashboard/search-workers");
    }
  }, [getSelectionIdFromCookies, navigate]);

  useEffect(() => {
    if (searchSelections?.genderDetails) {
      setSelectedGender(searchSelections.genderDetails);
    }
  }, [searchSelections]);

  useEffect(() => {
    onUpdate(selectedGender);
  }, [selectedGender, onUpdate]);

  const handleChange = (e) => {
    setSelectedGender(e.target.value);
    onUpdate(e.target.value);
    clearError();
  };

  return (
    <div className="worker-support-gender-container">
      <h2>Preferred gender?</h2>
      <div className="wsgc-container-wrapper">
        {genderOptions.genders.map((gender) => (
          <div className="wsgc-radio-container" key={gender.id}>
            <input
              id={gender.id}
              type="radio"
              name="genderPreference"
              value={gender.value}
              checked={selectedGender === gender.value}
              onChange={handleChange}
            />
            <label htmlFor={gender.id}>{gender.label}</label>
          </div>
        ))}
      </div>
      {isError && (
        <span className="wsgc-error-message">Please make a selection.</span>
      )}
    </div>
  );
};

export default WorkerSupportGender;
